import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, InputGroup } from "react-bootstrap";
import { BASE_URL } from "../../../constants";
import Select from 'react-select';
import axios from 'axios';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//const DiscountModal = ({ show, handleClose, handleSave }) => {
const ViewRcptkModal = ({ show, handleClose, onRowSelect }) => {


  const [searchRcptNo, setSearchRcptNo] = useState();
  const [searchGR_No, setSearchGR_No] = useState();
  const [searchSection, setSearchSection] = useState();

  const [searchResults, setSearchResults] = useState([]);
  const [ddlSections, setDdlSections] = useState([]);
  const [ddlGRNos, setDdlGRNos] = useState([]);

  useEffect(() => {
    
    const fetchLists = async () => {
      try {
        const [ sectionRes] = await Promise.all([
            axios.get(`${BASE_URL}/api/ddl_sections`),
        ]);

        setDdlSections(sectionRes.data);

        const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
        setDdlSections(sec.data);


      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchLists();

  }, []);

  const handleSearch = async () => {

    if (!searchSection || searchSection === '') {
      toast.error('Please select Section.');
      return;
    }
    //  else if ((!searchRcptNo || searchRcptNo === '') || (!searchGR_No || searchGR_No === '')) {
    //   toast.error('Please enter either Receipt No or GR No.');
    //   return;
    // }

    try {
      const response = await axios.get(`${BASE_URL}/api/get_receipt_view`, {
        params: {p_section_id: searchSection, p_rcpt_no: searchRcptNo || 0, p_gr_no: searchGR_No || 0},
      });

      setSearchResults(response.data);

    } catch (error) {
      console.error('Search failed:', error);
    }

  };

  const handleClear = async () => {
    setSearchGR_No(null);
    setSearchRcptNo('');
    setSearchSection('');
    setSearchResults([]);

  }

  const handleSectionChange = async (e) => {

    const sectionId = e.target.value;

    setDdlGRNos([]);
    setSearchSection(sectionId);
    setSearchGR_No(null);

    if (!sectionId) return;

    const studResponse = await axios.get(`${BASE_URL}/api/ddl_stud_name_gr`,
      { params: { p_Section_Id: sectionId } });

    setDdlGRNos(studResponse.data);
    
  }

  const handleGrChange = (selectedOption) => {

    try {

      setSearchGR_No(selectedOption ? selectedOption.value : "");

      // setHeaderData(prev => ({
      //   ...prev,
      //   gr_no: selectedOption ? selectedOption.value : "",
      //   stud_name: selectedOption ? selectedOption.label : ""
      // }));

    } catch (e) {
      toast.error('Unable to retrieve fees data.');
    }

  };

  const formatAmount = (amount) =>

    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });


  const grNoOptions = ddlGRNos.map(code => ({
    value: String(code.gr_no),
    label: code.stud_name
  })) || [];

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Search Receipt No.</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form className="mb-3">
          {/* === Row 1 === */}
          <div className="row mb-3">

            {/* Section Dropdown */}
            <Form.Group className="col-md-4">
                <Form.Select
                  value={searchSection}  onChange={handleSectionChange}>
                  {/* onChange={(e) => setSearchSection(e.target.value)}> */}
                  <option value="">-- Section --</option>
                  {ddlSections.map(sec => (
                    <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                  ))}
                </Form.Select>
            </Form.Group>

            <Form.Group className="col-md-4">
              <InputGroup>
                <InputGroup.Text style={{ width: "120px" }}>Receipt No</InputGroup.Text>
                <input style={{textAlign: 'right'}}
                  className="form-control"
                  name="searchRcptNo"
                  value={searchRcptNo}
                  onChange={(e) => setSearchRcptNo(e.target.value)}
                />
              </InputGroup>
            </Form.Group>

            <div className="col-md-2">
              <Button variant="primary" onClick={handleSearch} className="w-100">
                Search
              </Button>
            </div>
            <div className="col-md-2">
                 <Button variant="secondary" onClick={handleClear} className="w-100">
                Clear
              </Button>
            </div>

          </div>

          {/* === Row 2 === */}
          <div className="row align-items-end">

            <Form.Group className="col-md-12">
              <InputGroup>
                <InputGroup.Text style={{ width: "200px" }}>GR No. / Student Name</InputGroup.Text>
                <div style={{ flex: 1 }}>
                <Select name="searchGR_No"  
                  options={grNoOptions}
                  value={grNoOptions.find(option => String(option.value) === String(searchGR_No)) || null}
                  onChange={handleGrChange} placeholder="Search by GR No / Student name ..." />
                </div>
              </InputGroup>
            </Form.Group>
          </div>
        </Form>
        {/* <Table bordered hover responsive> */}
        <div style={{ minHeight: '430px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '7%', textAlign: 'left' }}>Receipt No.</th>
                <th style={{ width: '7%', textAlign: 'center' }}>Receipt Date</th>
                <th style={{ width: '33%', textAlign: 'left' }}>Student Name</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Std / Div</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Period</th>
                <th style={{ width: '12%', textAlign: 'right' }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr><td colSpan="6" className="text-center">No Data</td></tr>
              ) : (
                searchResults.map((row, index) => (
                  <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left' }}>{row.rcpt_no}</td>
                    <td style={{ textAlign: 'center' }}>{row.rcpt_date}</td>
                    <td style={{ textAlign: 'left' }}>{row.stud_name}</td>
                    <td style={{ textAlign: 'left' }}>{row.std_div}</td>
                    <td style={{ textAlign: 'left' }}>{row.from_period} <br/> {row.to_period}</td>
                    <td style={{ textAlign: 'right' }}>{formatAmount(row.fee_amt)}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* </Table> */}
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="warning" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewRcptkModal;
